module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_1.43c97d31.png";